export function trackLead(leadId) {
  if (typeof window.gtag !== 'function') return

  window.gtag('event', 'conversion', {
    send_to: 'AW-16971064629/v3UWCMH68LIaELXKt5w_',
    value: 1.0,
    currency: 'USD',
    ...(leadId ? { transaction_id: String(leadId) } : {})
  })

  // Opcional: evento equivalente en GA4
  window.gtag('event', 'generate_lead', {
    value: 1.0,
    currency: 'USD'
  })
}